import React from 'react';
import { default as ReactCalendar } from 'react-calendar'; // import './Calendar.css';

import { jsx as _jsx } from "react/jsx-runtime";
export function Calendar(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange;
  return /*#__PURE__*/_jsx(ReactCalendar, {
    onChange: onChange,
    value: value,
    defaultView: "month",
    minDetail: "month",
    maxDetail: "month",
    maxDate: new Date(),
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
    className: "mx-auto border-none"
  });
}
export default Calendar;